import React, {useEffect, useState} from "react";
import {useRecoilState} from "recoil";
import {answersState, nextAbleQuestionsState} from "../../states/test_progress_states";
import {getQuestionAnswers, getSelectedCode} from "../../helpers/QuestionHelper";

const withQuestionLogic = BaseComponent => (props) => {
    const {question} = props;
    const [nextAbleQuestions, setNextAbleQuestions] = useRecoilState(nextAbleQuestionsState);
    const [answers, setAnswers] = useRecoilState(answersState);

    //Lưu trong state vì group sẽ cùng lúc hiện nhiều câu khác nhau, không thể lưu trong recoil được.
    const [selectedCode, setSelectedCode] = useState([]);
    const [studentAnswers, setStudentAnswers] = useState([]);

    /**
     * Tính toán đáp án chọn của học viên để hiển thị
     */
    useEffect(() => {
        setStudentAnswers(getQuestionAnswers(question, answers));
        setSelectedCode(getSelectedCode(question, answers));
    }, [question, answers]);

    /**
     * Xử lý logic cho phép next.
     * Tạo 1 mảng các question được next.
     * Khi question thỏa mãn các yêu cầu thì gọi đến hàm này để đánh dấu question đã next được
     */
    const markNextAble = (nextAble = true) => {
        if (nextAble && nextAbleQuestions.includes(question.questionCode) === false){
            setNextAbleQuestions([...nextAbleQuestions, question.questionCode]);
        }else if (!nextAble && nextAbleQuestions.includes(question.questionCode) === true){
            setNextAbleQuestions(nextAbleQuestions.filter(
                nextAbleCode => nextAbleCode !== question.questionCode
            ));
        }
    };

    /**
     * Logic cập nhật lại đáp án
     * @param questionCode
     * @param studentAnswers
     */
    const selectAnswer = (questionCode, studentAnswers) => {
        // Get all answers except those for the current question (if any)
        const newAnswersArray = answers.filter(
            answer => answer.questionCode !== questionCode
        );

        studentAnswers.forEach(studentAnswer => {
            newAnswersArray.push(studentAnswer);
        });
        // Add the new answer and update the state
        setAnswers(newAnswersArray);
    };

    return (
        <React.Fragment>
            <BaseComponent {...props}
                           markNextAble={markNextAble} selectedCode={selectedCode}
                           studentAnswers={studentAnswers} selectAnswer={selectAnswer}/>
        </React.Fragment>
    );
};

export default withQuestionLogic;